import axios from "axios";
import config from '../constants/config';
import { handleApiError } from "../utils/apiErrorHandler";

const API_URL = config.apiBaseUrl; // your backend URL
const JWT_SECRET_KEY = config.JWT_SECRET_KEY;

const adminService = {
    // get
    getUsers: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.get(`${API_URL}/admin/get_user_list`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getConfigs: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.get(`${API_URL}/admin/get_config_list`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getGeofenceList: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.get(`${API_URL}/admin/get_geofence_list`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getVehicleList: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.get(`${API_URL}/admin/get_vehicle_list`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getCountry: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.get(`${API_URL}/admin/get_country`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getCity: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.get(`${API_URL}/admin/get_city`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getChatMsg: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.get(`${API_URL}/admin/get_chat_msg`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getSubscription: async (params) => {
        const authToken = params.authToken;
        delete params.authToken;

        try {
            const response = await axios.get(`${API_URL}/admin/get_subscription`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getPaymentMode: async (params) => {
        const authToken = params.authToken;
        delete params.authToken;

        try {
            const response = await axios.get(`${API_URL}/admin/get_payment_mode`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getPaymentHistory: async (params) => {
        const authToken = params.authToken;
        delete params.authToken;

        try {
            const response = await axios.get(`${API_URL}/admin/get_payment_history`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getCompany: async () => {
        try {
            const response = await axios.get(`${API_URL}/admin/get_company`);
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getCompanyList: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';
        try {
            const response = await axios.get(`${API_URL}/admin/get_company_list`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getEnquiryList: async () => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';
        try {
            const response = await axios.get(`${API_URL}/admin/get_enquiry_list`, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    //   post

    getCityByCountry: async (id) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/get_city_by_country`, { countryId: id }, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            }
            );

            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    saveConfig: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';
        try {
            const response = await axios.post(`${API_URL}/admin/save_config`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    saveGeofence: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/save_geofence`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    saveCompany: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/save_company`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    updateVehicle: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/update_vehicle`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    updateUser: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/update_user`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    updateCompStatus: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/update_comp_status`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    saveCountry: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/save_country`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    saveCity: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';

        try {
            const response = await axios.post(`${API_URL}/admin/save_city`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    saveChatMsg: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';
        try {
            const response = await axios.post(`${API_URL}/admin/save_chat_msg`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    getReasions: async (params) => {
        const user = JSON.parse(localStorage.getItem("user") || '{}');
        const authToken = user?.authToken || '';
        try {
            const response = await axios.post(`${API_URL}/admin/get_reasions`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    saveSubscription: async (params) => {
        const authToken = params.authToken;
        delete params.authToken;
        try {
            const response = await axios.post(`${API_URL}/admin/save_subscription`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

    savePaymentMode: async (params) => {
        const authToken = params.authToken;
        delete params.authToken;
        try {
            const response = await axios.post(`${API_URL}/admin/save_payment_mode`, params, {
                headers: {
                    'Authorization': `${JWT_SECRET_KEY} ${authToken}`
                }
            });
            return response.data;
        } catch (error) {
            handleApiError(error);
        }
    },

};

export default adminService;
